import { useEffect } from 'react'
import { FIRST_FRAME_TIMEOUT_MS } from './constants'

// restartKey เปลี่ยน (URL ใหม่ / กด retry) = เริ่มนับใหม่ · หมดเวลาแปลว่าอะไรให้คนเรียกตัดสิน
export default function useFirstFrameTimeout(waiting, restartKey, onTimeout) {
  useEffect(() => {
    if (!waiting) return undefined
    const timer = setTimeout(onTimeout, FIRST_FRAME_TIMEOUT_MS)
    return () => clearTimeout(timer)
  }, [waiting, restartKey, onTimeout])
}
